import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { DiscountDetails } from '@/types';
import {
  isDiscountValidForLocationAndSku,
  removeDiscountParamFromURL,
} from '@/utils/handleDiscount';
import { isWithinInterval } from 'date-fns';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useShallow } from 'zustand/react/shallow';

export const useDiscountRemovalPopup = (): any => {
  const { slot, discount, locationId, skuId, clearScan, addToPaymentSlice } = usePrenuvoStore(
    useShallow((state) => ({
      slot: state.scan.slot,
      discount: state.payment.discount,
      locationId: state.scan.locationId,
      skuId: state.scan.sku?.skuID,
      clearScan: state.scan.methods.clearScan,
      addToPaymentSlice: state.payment.methods.add,
    })),
  );
  const [, , removeCookie] = useCookies();

  const [showDiscountRemovalPopup, setShowDiscountRemovalPopup] = useState<boolean>(false);
  const [discountIsValid, setDiscountIsValid] = useState<boolean>(false);

  useEffect(() => {
    if (!slot?.utcStart || !discount?.bookingValidFrom || !discount?.bookingValidTo) return;

    const inDateRange = isWithinInterval(new Date(slot?.utcStart * 1000), {
      start: new Date(discount?.bookingValidFrom * 1000),
      end: new Date(discount?.bookingValidTo * 1000),
    });

    if (!inDateRange) setShowDiscountRemovalPopup(true);
  }, [slot?.utcStart, discount?.bookingValidFrom, discount?.bookingValidTo]);

  useEffect(() => {
    if (!discount || !discount.validLocations || !discount.validSkus) return;

    if (skuId) setDiscountIsValid(isDiscountValidForLocationAndSku(discount, locationId, skuId));
  }, [discount, locationId, skuId]);

  const discountIsAvailable = !!(
    slot &&
    discount &&
    discount.bookingValidFrom &&
    discount.bookingValidTo &&
    slot.utcStart
  );

  const setDiscountInfo = (value: null | DiscountDetails) => addToPaymentSlice({ discount: value });

  const handleProceedWithoutDiscount = () => {
    setShowDiscountRemovalPopup(false);
    removeDiscountParamFromURL();
    setDiscountInfo(null);
    removeCookie('discount', { path: '/' });
    removeCookie('PROMOCODE', { path: '/' });
  };

  const handleSelectDifferentDate = async () => {
    setShowDiscountRemovalPopup(false);
    clearScan();
  };

  return {
    discountIsAvailable,
    showDiscountRemovalPopup,
    discountIsValid,
    handleProceedWithoutDiscount,
    handleSelectDifferentDate,
  };
};
